<template>
    <div class="BusinessCard" style="bottom:0;">
        <div class="screenSearchPop" style="bottom:0">
            <div class="imgBox imgBox1" v-if="imgUrl !== ''">
                <div class="filter"></div>
                <img :src="imgUrl" class="img1" @click="showImg()" :onerror="defaultImg" />
                <div class="clickPhone" @click="scanning()">
                    <i class="van-icon van-icon-photograph"></i>
                </div>
            </div>
            <div class="imgBox imgBox2" v-show="imgUrl == ''">
                <div class="img2">
                    <van-uploader :after-read="onRead" ref="vanUploader">
                        <van-icon name="photograph" />
                    </van-uploader>
                </div>
            </div>
            <!-- 数据解析中...请稍等 -->
            <loading-new :loading="loading" :text="$t('mx_mobile.Client.1585548023204')" style="margin-top:40px"></loading-new>
            <template v-if="!loading&&initState">
            </template>
        </div>
    </div>
</template>
<script>
import loadingNew from '@/page/Client/CustPublic/LoadingVue/index.vue'
import { mapGetters, mapMutations } from 'vuex'
import { ImagePreview } from 'vant'
import { getIsApp } from '@/libs/utils'

export default {
    name: 'BusinessCard',
    title: function fc() { return this.$t('mx_mobile.Client.1585548055236') }, // '名片扫描'
    props: {
        sysBoxValue: {
            type: Array,
            default: function () {
                return []
            }
        },
        AONIcustSort: {
            type: Array,
            default: function () {
                return []
            }
        },
        currency: {
            type: Array,
            default: function () {
                return []
            }
        },
        cusBoxValue: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            imgUrl: '',
            custData: {},
            loading: false,
            initState: false,
            submitLoading: false,
            optCode: 'otNew',
            defaultImg: 'this.src="/images/noData/noCustomer.png"',
            rightFlag: true
        }
    },
    mounted() {
        this.setMenu()
    },
    methods: {
        ...mapMutations({
            set_closeYes: 'SET_CLOSEYES'
        }),
        checkPhone(phone) {
            let trim = (str, isglobal) => {
                var result
                result = str.replace(/(^\s+)|(\s+$)/g, '')
                if (isglobal && isglobal.toLowerCase() === 'g') {
                    result = result.replace(/\s/g, '')
                }
                return result
            }
            phone = trim(phone, 'g')
            // var reg = /^(\+?|0?|86?|086?)?1[356789]\d{9}$/
            var reg = /^(\+?)?[0-9]*$/
            return !!reg.test(phone)
        },
        showImg() {
            let list = []
            list.push(this.imgUrl)
            ImagePreview({
                images: list,
                startPosition: 0
            })
        },
        async onRead(file) {
            try {
                this.upLoad(file)
                this.custData = {}
                this.imgUrl = file.content
                let url = this.Global.config.apiBaseURL + this.Global.api.client.cardscan.client_cardscan
                let fd = new FormData()

                this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: this.$t('mx_mobile.Client.1585548196944') // 压缩中。。。
                })
                const fileBlob = getIsApp() ? file.file : await this.Global.utils.imageUtils.compress(file.file, 0.7)
                this.$toast.clear()

                fd.append('file', fileBlob)
                this.loading = true
                this.$emit('cardLoading', this.loading)
                this.axios.post(url, fd).then((res) => {
                    this.loading = false
                    this.$emit('cardLoading', this.loading)
                    if (res.data.code.toString() == this.Global.config.RES_OK) {
                        this.custData = this.analyzeScanData(res.data.data)
                        this.$emit('getCustData', this.custData)
                    } else {
                        this.$toast.fail(this.$t('mx_mobile.Client.1585548149477'))// '图片未识别到信息，请重试！'
                    }
                }, (res) => {
                    this.loading = false
                    this.$emit('cardLoading', this.loading)
                    this.$toast.fail(this.$t('mx_mobile.Client.1585548149477'))// 图片解析接口异常，请重试
                })
            } catch (e) {
                this.cardImagesId = ''
                alert(e)
            }
        },
        upLoad(file) {
            let files = []
            files.push(file.file)
            let data = {
                url: this.Global.config.uploadUrl,
                FileList: files,
                onprogress: (event) => { // 上传进度
                },
                onloadstart: (event) => { // 开始上传
                },
                onload: (res) => { // 上传成功
                    if (res.code.toString() === this.Global.config.RES_OK) {
                        this.cardImagesId = res.data || ''
                    } else {
                        this.cardImagesId = ''
                        this.$toast.fail(res.msg)
                    }
                }
            }
            this.Global.utils.fileUpload(data)
        },
        getCustData() {
            let custData = this.Global.utils.getItem('businessCardData')
            if (custData) {
                this.custData = JSON.parse(this.Global.utils.getItem('businessCardData'))
                this.$emit('getCustData', this.custData)
            } else {
                this.custData = {}
                this.$emit('getCustData', this.custData)
            }
            this.Global.utils.removeItem('businessCardData')
            this.transData()
        },
        transData() {
        },
        submitAddFrom() { // 提交新增客户数据
            this.$emit('submitAddFrom')
        },
        setMenu() {
            this.setHeaderTitle(this.$t('mx_mobile.Client.1585548055236'))// 名片扫描
            setTimeout(() => {
                let setMenu = this.Global.utils.rightMenu.setMenu(this.$t('mx_mobile.Client.1585301134763'))// 保存
                setMenu.onClick(() => {
                    this.submitAddFrom()
                })
            }, 100)
        },
        async scanning() {
            this.custData = {}
            this.imgUrl = ''
            this.$refs.vanUploader.$refs.input.click()
        },
        /* 扫描结果提取 */
        analyzeScanData(data) {
            if (Object.keys(data).length <= 0) return
            let Obj = {
                custAddr: '',
                web: '',
                custName: '',
                deptName: '',
                mobile: '',
                tel: '',
                mailAddress: '',
                contName: '',
                jobs: ''
            }
            if (data['address'] && this.Global.utils.isArray(data['address'])) {
                let address = data['address'][0]['item']
                let country = address['country'] ? address['country'] : ''
                let region = address['region'] ? address['region'] : ''
                let locality = address['locality'] ? address['locality'] : ''
                let street = address['street'] ? address['street'] : ''
                Obj['custAddr'] = country + region + locality + street
            }
            if (data['url'] && this.Global.utils.isArray(data['url'])) {
                if (data['url'].length > 0) { Obj['web'] = data['url'][0]['item'] }
            }
            if (data['organization'] && this.Global.utils.isArray(data['organization'])) {
                let org = data['organization']
                /* 优先取中文 没有取到随便取 */
                let pattern = new RegExp('.*[\u4e00-\u9fa5]+.*$')

                let newOrg = org.filter(item => {
                    pattern.lastIndex = 0
                    return item['item']['name'] && pattern.test(item['item']['name'])
                })

                if (newOrg.length > 0) {
                    Obj['custName'] = newOrg[0]['item']['name']
                } else {
                    let temp = org.filter(item => item['item']['name'])
                    if (temp.length > 0) {
                        Obj['custName'] = temp[0]['item']['name']
                    }
                }

                /* 部门 */
                let deptName = org.filter(item => item['item']['unit'] && pattern.test(item['item']['unit']))
                if (deptName.length > 0) {
                    Obj['deptName'] = deptName[0]['item']['unit']
                } else {
                    let tempDeptName = org.filter(item => item['item']['unit'])
                    if (tempDeptName.length > 0) {
                        Obj['deptName'] = tempDeptName[0]['item']['unit']
                    }
                }
            }

            if (data['telephone'] && this.Global.utils.isArray(data['telephone'])) {
                let telArr = data['telephone']

                let mobile = telArr.filter(item => item['item']['type'].includes('cellular'))
                if (mobile.length > 0) {
                    Obj['mobile'] = mobile[0]['item']['number']
                }

                /* 电话 */
                let tel = telArr.filter(item => !this.checkPhone(item['item']['number']) && (!item['item']['type'].includes('facsimile')))
                if (tel.length > 0) {
                    Obj['tel'] = tel[0]['item']['number']
                }

                let fax = telArr.filter(item => (!this.checkPhone(item['item']['number'])) && item['item']['type'].includes('facsimile'))
                if (fax.length > 0) {
                    Obj['fax'] = fax[0]['item']['number']
                }
            }
            /* 邮件 */
            if (data['email'] && this.Global.utils.isArray(data['email'])) {
                if (data['email'].length > 0) {
                    Obj['mailAddress'] = [data['email'][0]['item']]
                }
            }
            /* 人员名称 */
            if (data['formatted_name'] && this.Global.utils.isArray(data['formatted_name'])) {
                if (data['formatted_name'].length > 0) {
                    Obj['contName'] = data['formatted_name'][0]['item']
                }
            }
            /* 职位 */
            if (data['title'] && this.Global.utils.isArray(data['title'])) {
                let title = data['title']
                let pattern = new RegExp('.*[\u4e00-\u9fa5]+.*$')
                let jobs = title.filter(item => pattern.test(item['item']))
                if (jobs.length > 0) {
                    Obj['jobs'] = jobs[0]['item']
                } else {
                    Obj['jobs'] = title[0]['item']
                }
            }
            return Obj
        }
    },
    beforeRouteLeave(to, from, next) {
        const flag = this.Global.utils.chosen.close()
        const flag2 = this.Global.utils.actionSheet.close()
        const flag3 = this.Global.utils.prompt.close()
        if (flag || flag2 || flag3) {
            next(false)
        } else if (this.closeYes) {
            this.$dialog.confirm({
                title: this.$t('mx_mobile.Client.1585304004347'), // 提示
                message: this.$t('mx_mobile.Client.1585304000139'), // '已编辑内容将不会保存，是否确定离开？'
                closeOnPopstate: false
            }).then(() => {
                this.initState = false
                this.imgUrl = ''
                this.custData = {}
                next()
            }).catch(() => {
                next(false)
            })
        } else {
            this.set_closeYes(true)
            next()
        }
    },
    computed: {
        ...mapGetters(['closeYes'])
    },
    watch: {
        $route(val, old) {
            if (val.path.indexOf('/client/businessCard') != -1) {
                this.setMenu()
                this.getCustData()
            } else {
                if (this.initState) {
                    this.initState = false
                }
            }
        }
    },
    components: {
        'loading-new': loadingNew
    }
}
</script>

<style lang="less" scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
